import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IAnimCategory } from '@src/slide/domain/ui-model/element-modeles/property/animation/constants';
import { AnimType } from '@tencent/slide-sdk-model';
import { ISelectionService } from '../selection/selection-service.interface';
import { ISelectedAnimManager } from '../selection/selected-anim-manager.interface';

export interface IAnimCategoryManager {
    getAnimCategoryList(animCategoryList: IAnimCategory[]): IAnimCategory[];
    getAnimCategoryListByElement(
        elementModelList: IElementBaseModel[],
        animCategoryList: IAnimCategory[],
    ): IAnimCategory[];
    getDisabledAnimTypeList(elementModel: IElementBaseModel): AnimType[];
    setServiceDelegates(services: IServices): void;
}

export interface IServices {
    selectionService: ISelectionService;
    selectedAnimManager: ISelectedAnimManager;
}

export enum ElementType {
    IMAGE = 'Image',
    TABLE = 'Table',
    GROUP = 'Group',
    CONNECTOR = 'Connector',
    CHART = 'Chart',
    SHAPE = 'Shape',
    SHAPE_WITH_TEXT = 'shape_with_text',
    SHAPE_NO_TEXT = 'shape_no_text',
    SHAPE_WITH_ADDON = 'shape_with_addon', // 插件
    IMAGE_NO_MEDIA = 'image_no_media', // 纯图片
    IMAGE_WITH_MEDIA = 'image_with_media', // 音视频
}
